export default "__VITE_ASSET__jtP7YfM8__"